import React from 'react';

const getScoreRankStyle = (rank: string | null | undefined): string => {
  const upperRank = rank?.toUpperCase();
  switch (upperRank) {
    case 'A':
      return 'text-[var(--score-green-foreground)] bg-[var(--label08)]';
    case 'B':
      return 'bg-blue-100 text-blue-600';
    case 'C':
      return 'text-[var(--score-orange-foreground)] bg-[var(--label07)]';
    case 'D':
      return 'bg-gray-100 text-gray-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

interface ScoreRankBadgeProps {
  rank: string | null | undefined;
  className?: string;
}

export const ScoreRankBadge: React.FC<ScoreRankBadgeProps> = ({rank, className = ''}) => {
  return (
    <div
      className={`w-6 h-6 rounded flex items-center justify-center text-base font-bold ${getScoreRankStyle(rank)} ${className}`}>
      {rank?.toUpperCase()}
    </div>
  );
};